module.exports = __webpack_public_path__ + "img/Vue-BusApp-mobile.5bc68391.png";